import { AlignVerticalBottom, AlignVerticalCenter, AlignVerticalTop, ArrowLeft, ArrowRight, Delete, FormatAlignCenter, FormatAlignLeft, FormatAlignRight } from '@mui/icons-material';
import { Box, Button, ButtonGroup, TextField, Typography } from '@mui/material';
import { LabelItem, LabelItemPrintZoneProps, LabelItemType, Lang, labelEditorSlice } from 'cdx-common';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState, appStore } from 'store';
import { LabelItemColumnSelector } from './labelitemcolumnselector';


const BaseItemProps = () => {

    const currentLabel = useSelector((state: RootState) => state.labelEditor.currentLabel);
    const selectedLabelItem = useSelector((state: RootState) => state.labelEditor.selectedLabelItem);
    const item = useSelector((state: RootState) => state.labelEditor?.currentLabel?.items[selectedLabelItem ?? -1]);

    useEffect(() => {
        setInputValues({
            x: item?.props.x + '',
            y: item?.props.y + '',
            w: item?.props.width + '',
            h: item?.props.height + '',
        });
    }, [selectedLabelItem]);

    const [inputValues, setInputValues] = useState<{ x: string, y: string, w: string, h: string; }>({ x: '', y: '', w: '', h: '' });



    const updateAttr = (attrs: Partial<LabelItem>) => {
        if (selectedLabelItem !== undefined) {
            appStore.dispatch(labelEditorSlice.actions.updatePrintLabelItemAttrs({
                index: selectedLabelItem,
                attrs
            }));
        }
    };

    const updateProp = (props: Partial<LabelItemPrintZoneProps>) => {
        if (selectedLabelItem !== undefined) {
            appStore.dispatch(labelEditorSlice.actions.updatePrintLabelItemProps({
                index: selectedLabelItem,
                props
            }));
        }
    };


    const getContentRelatedControl = () => {
        if (item) {
            switch (item.type ?? null) {
                case LabelItemType.STATIC_TEXT:
                    return <TextField
                        size='small'
                        label='Contenu'
                        margin='normal'
                        value={item.value ?? ''}
                        onChange={(event) => {
                            updateAttr({ value: event.target.value ?? '' });
                        }} />;
                case LabelItemType.DYNAMIC_TEXT:
                case LabelItemType.QRCODE:
                case LabelItemType.BARCODE:
                    return (selectedLabelItem !== undefined && currentLabel) ? <LabelItemColumnSelector printLabel={currentLabel} index={selectedLabelItem} /> : null;
                default:
                    break;
            }
        }
        return <TextField
            size='small'
            label='Contenu'
            margin='normal'
            disabled
            value={'Sélectionner un item...'} />;
    };

    return <>
        <Box>
            <Button variant='outlined' size='small' disabled={!selectedLabelItem} onClick={() => {
                if (selectedLabelItem) appStore.dispatch(labelEditorSlice.actions.setSelectedItemLabel(selectedLabelItem - 1));
            }}><ArrowLeft /></Button>
            {selectedLabelItem === undefined ? <Typography component='span' variant='body1' color='gray'>Item #</Typography> : <Typography component='span' variant='body1'>Item #{selectedLabelItem + 1}</Typography>}
            <Button variant='outlined' size='small' disabled={!currentLabel?.items.length} onClick={() => {
                appStore.dispatch(labelEditorSlice.actions.setSelectedItemLabel(selectedLabelItem === undefined ? 0 : (selectedLabelItem + 1)));
            }}><ArrowRight /></Button>
            <Button variant='outlined' size='small' disabled={selectedLabelItem === undefined} onClick={() => {
                if (selectedLabelItem !== undefined) appStore.dispatch(labelEditorSlice.actions.removeCurrentLabelItem());
            }}><Delete /> Supprimer</Button>
        </Box>
        {item && <Box>
            <Typography>Élément {Lang('labelEditor.labelType.' + item?.type)}</Typography>
        </Box>}
        <Box>
            {getContentRelatedControl()}
        </Box>

        <Box>
            <TextField
                type='number'
                inputProps={{
                    step: "1"
                }}
                size='small'
                label='x'
                margin='normal'
                value={item ? item.props.x : ''}
                disabled={!item}
                onChange={(event) => {
                    setInputValues({ ...inputValues, x: event.target.value });
                    if (parseFloat(event.target.value ?? '')) {
                        updateProp({ x: parseFloat(event.target.value ?? '') });
                    }
                }}
            />
            <TextField
                type='number'
                inputProps={{
                    step: "1"
                }}
                size='small'
                label='y'
                margin='normal'
                value={item ? item.props.y : ''}
                disabled={!item}
                onChange={(event) => {
                    setInputValues({ ...inputValues, y: event.target.value });
                    if (parseFloat(event.target.value ?? '')) {
                        updateProp({ y: parseFloat(event.target.value ?? '') });
                    }
                }}
            />
        </Box><Box>
            <TextField
                type='number'
                size='small'
                label='Largeur'
                margin='normal'
                value={item ? item.props.width : ''}
                disabled={!item}
                onChange={(event) => {
                    setInputValues({ ...inputValues, w: event.target.value });
                    if (parseInt(event.target.value ?? '')) {
                        if (item?.type === LabelItemType.QRCODE) {
                            updateProp({
                                width: parseInt(event.target.value ?? ''),
                                height: parseInt(event.target.value ?? '')
                            });
                        } else {
                            updateProp({ width: parseInt(event.target.value ?? '') });
                        }

                    }
                }}
            />
            <TextField
                type='number'
                size='small'
                label='Hauteur'
                margin='normal'
                value={item ? item.props.height : ''}
                disabled={!item}
                onChange={(event) => {
                    setInputValues({ ...inputValues, h: event.target.value });
                    if (parseInt(event.target.value ?? '')) {
                        if (item?.type === LabelItemType.QRCODE) {
                            updateProp({
                                width: parseInt(event.target.value ?? ''),
                                height: parseInt(event.target.value ?? '')
                            });
                        } else {
                            updateProp({ height: parseInt(event.target.value ?? '') });
                        }
                    }
                }}
            />
        </Box><Box>
            <TextField
                type='number'
                inputProps={{
                    step: "0.5"
                }}
                size='small'
                label='Texte'
                margin='normal'
                value={item ? item.props.fontSize : ''}
                disabled={!item}
                onChange={(event) => {
                    updateProp({ fontSize: parseFloat(event.target.value ?? '') });
                }}
            />
        </Box>
        <Box margin='normal'>
            <ButtonGroup variant='contained'>
                <Button
                    disabled={!item}
                    variant={(item && item.props.textAlign === undefined) ? 'contained' : 'outlined'}
                    onClick={() => updateProp({
                        justifyContent: undefined,
                        textAlign: undefined
                    })}><FormatAlignLeft /></Button>
                <Button
                    disabled={!item}
                    variant={(item && item.props.textAlign === 'center') ? 'contained' : 'outlined'}
                    onClick={() => updateProp({
                        justifyContent: 'center',
                        textAlign: 'center',
                    })}
                ><FormatAlignCenter /></Button>
                <Button
                    disabled={!item}
                    variant={(item && item.props.textAlign === 'right') ? 'contained' : 'outlined'}
                    onClick={() => updateProp({
                        justifyContent: 'end',
                        textAlign: 'right'
                    })}
                ><FormatAlignRight /></Button>
            </ButtonGroup>
            <ButtonGroup variant='contained'>
                <Button
                    disabled={!item}
                    variant={(item && item.props.alignItems === undefined) ? 'contained' : 'outlined'}
                    onClick={() => updateProp({ alignItems: undefined })}
                ><AlignVerticalTop /></Button>
                <Button
                    disabled={!item}
                    variant={(item && item.props.alignItems === 'center') ? 'contained' : 'outlined'}
                    onClick={() => updateProp({ alignItems: 'center' })}
                ><AlignVerticalCenter /></Button>
                <Button
                    disabled={!item}
                    variant={(item && item.props.alignItems === 'end') ? 'contained' : 'outlined'}
                    onClick={() => updateProp({ alignItems: 'end' })}
                ><AlignVerticalBottom /></Button>
            </ButtonGroup>
        </Box >
    </>;
};

export const LabelItemPropsEditor = () => {
    return <Box component='form' noValidate autoComplete='off'>
        <BaseItemProps />
    </Box>;
};
